import { CONTRACT_MODEL, RATE_MODEL_TYPE } from '@/helpers/constants'
import { ApiManager } from '@/services/http/ApiManager'

export const SET_CURRENT_MODEL = 'SET_CURRENT_MODEL'

export const rateModel = {
  namespaced: true,
  state: {
    rateModel: {},
  },
  actions: {
    async [SET_CURRENT_MODEL] ({ commit }, rateModelId) {
      const rateModelResp = await ApiManager.requestModel(rateModelId)
      commit('rateModel/set', rateModelResp.data, { root: true })
    }
  },
  mutations: {
    set: (state, payload) => {
      state.rateModel = { ...payload }
    },
  },
  getters: {
    areDiscountsBlocked: state => !!state.rateModel.discountsBlocked,

    contractModel: state =>
      state.rateModel.rateModelDesc.contractModel || CONTRACT_MODEL.PDF_VENTA_DIRECTA_2021,

    isTypeBroker: state => state.rateModel.rateModelType === RATE_MODEL_TYPE.BROKER,

    isTypeF: state => state.rateModel.type == RATE_MODEL_TYPE.F,
  },
}
